export const mapLocationToAPI = (data) => ({
    data: {
        type: "locations",
        ...(data.id && { id: data.id }),
        attributes: {
            // if id exists then its edit request
            locationType: data.tags.length === 2 ? "both" : data.tags[0],
            area: data.area,
            city: data.city,
            address: data.googleLocationDetails,
            latitude: data.lat,
            longitude: data.lang,
            organizationId: data.client.value,
            governorate: data.gov,
            name: data.locationName,
            nameAr: data.nameAr,
            nameEn: data.nameEn,
            streetAndBuildingNumber: data.street,
            locationCategoryId: data.category?.value,
            description: data.description,
            clientIdentifierCode: data.clientCode,
        },
    },
});
